export interface UnitsGridFirstColumnNormalizationOptions {
  readonly dedupeByFirstColumn: boolean;
  readonly sortByFirstColumn: boolean;
  readonly dedupePrecision: number;
}

export function normalizeUnitsGridRowsByFirstNumericColumn(
  parsedRows: readonly (readonly string[])[],
  options: UnitsGridFirstColumnNormalizationOptions
): readonly (readonly string[])[] {
  if (!parsedRows.length) {
    return parsedRows;
  }

  const firstColumnValues = parsedRows.map((row) => Number(row[0]));
  if (firstColumnValues.some((value) => !Number.isFinite(value))) {
    return parsedRows;
  }

  const dedupedRows = options.dedupeByFirstColumn
    ? dedupeRowsByFirstColumn(parsedRows, options.dedupePrecision)
    : [...parsedRows];

  if (!options.sortByFirstColumn) {
    return dedupedRows;
  }

  return [...dedupedRows].sort((a, b) => Number(a[0]) - Number(b[0]));
}

function dedupeRowsByFirstColumn(
  parsedRows: readonly (readonly string[])[],
  precision: number
): readonly (readonly string[])[] {
  const uniqueRows = new Map<number, readonly string[]>();

  parsedRows.forEach((row) => {
    const firstValue = Number(row[0]);
    const normalizedKey = Number(firstValue.toFixed(precision));

    if (!uniqueRows.has(normalizedKey)) {
      uniqueRows.set(normalizedKey, row);
    }
  });

  return [...uniqueRows.values()];
}
